var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0603 27.8669L31.0381 14.8891C34.2269 11.7003 34.6973 6.4543 31.6797 3.10314C30.9238 2.2613 30.0043 1.5823 28.9774 1.10756C27.9504 0.632817 26.8375 0.372291 25.7065 0.341877C24.5755 0.311464 23.4502 0.511801 22.3992 0.930664C21.3482 1.34953 20.3936 1.97813 19.5936 2.77813L17.1543 5.21737L15.0483 3.11133C11.8595 -0.0774524 6.61348 -0.547906 3.26232 2.46976C2.42048 3.22563 1.74148 4.1451 1.26674 5.17207C0.791996 6.19903 0.53147 7.31195 0.501057 8.44293C0.470643 9.57391 0.67098 10.6992 1.08984 11.7502C1.50871 12.8012 2.13731 13.7558 2.93731 14.5559L16.2483 27.8669C16.4886 28.1072 16.8145 28.2422 17.1543 28.2422C17.4941 28.2422 17.82 28.1072 18.0603 27.8669Z",
    fill: "#FF1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFill);
export default __webpack_public_path__ + "static/media/heartFill.8c0e1c2d77c0f2694c1834d9044f15cf.svg";
export { ForwardRef as ReactComponent };